import { ParmConfigAdd, GetParmConfig, ParmConfigDel } from '@api/commonApi.js';
import { lg, cloneDeep, isCorrectVal, util } from 'utils';

export default {
    components: {},
    props: {},
    data() {
        return {
            visibleShow: false,
            Logistics: [],
            dialogContent: "",
            loading: false,
            model: {}
        };
    },
    computed: {

    },
    methods: {
        getModel() {
            return cloneDeep({

            });
        },
        show(options) {
            let opts = Object.assign({}, {

            }, options);
            this.visibleShow = true;
            this.getLogistics();

        },
        delLogistics(item) {

            this.$confirm('确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                ParmConfigDel({
                    Ids: item.Id
                }).then(res => {
                    this.loading = false;
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    util.doResult(this, res, () => {
                        this.getLogistics(() => {
                            this.$emit('deleteMailCallBack', {
                                Id: item.Id,
                                list: cloneDeep(this.Logistics)
                            });
                        });
                    });
                });
            }).catch(() => {});
        },
        addLogistics() {
            var para = {
                ParmType: 10,
                ParmName: this.dialogContent
            };
            this.loading = true;
            ParmConfigAdd(para).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.dialogContent = "";
                    this.visibleShow = false;
                    this.getLogistics(() => {
                        let cell = this.Logistics[this.Logistics.length - 1];
                        this.$emit('addMailCallback', {
                            Id: cell.Id,
                            ParmName: cell.ParmName
                        });
                    });
                });
            });
        },
        closeCallback() {},
        getLogistics(callback) {
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                ParmType: 10
            };
            GetParmConfig(para).then(res => {
                util.doResult(this, res, () => {
                    this.Logistics = res.data.Data;
                    if (typeof callback == "function") {
                        callback();
                    }
                });
            });
        }
    },
    mounted() {

    }
};


// WEBPACK FOOTER //
// ./src/common/components/mailManagerDialog/vm.js